var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendBuilderEffecti = function SvgLegendBuilderEffecti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: props.color || 'currentColor',
    rx: 2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.355 17.746a1.09 1.09 0 0 1-.1-1.5l.1-.1 4.7-4.1.7.2.2.7-4.1 4.7a1.23 1.23 0 0 1-.854.355.9.9 0 0 1-.646-.255m7.307-4.146-.8-2.4-2.4-.7a.31.31 0 0 1 0-.4l1.9-1.4-.1-2.5a.22.22 0 0 1 .2-.2h.1l2 1.5 2.2-.8h.1c.1 0 .2.2.2.3l-.6 2.4 1.5 2c.1.1 0 .295-.2.2h-2.4l-1.3 2c-.1.1-.1.1-.2.1s-.199 0-.199-.1zm-.3-4.4-1.1.8 1.4.4.4 1.295.7-1.1 1.3.1-.8-1.1.5-1.4-1.3.5-1.1-.8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendBuilderEffecti);
export default ForwardRef;